<template>
  <div class="home_activity">
    <div class="home_activity_top">
      <div class="home_activity_title">开发者活动</div>
      <!-- <div class="home_skip_btn">
        <div
          class="btn left"
          :class="{ disable: currentPage === 1 }"
          @click="handleSkip(1)"
        >
          <svg
            class="btn_img"
            width="21"
            height="21"
            viewBox="0 0 21 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g id="chevron-left">
              <path
                id="Vector"
                d="M13.292 15.9395L8.29199 10.9395L13.292 5.93945"
                stroke="#D1D5DB"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </g>
          </svg>
        </div>
        <div
          class="btn"
          :class="{ disable: currentPage === pageTotal }"
          @click="handleSkip(2)"
        >
          <svg
            class="btn_img"
            width="21"
            height="21"
            viewBox="0 0 21 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g id="chevron-right">
              <path
                id="Vector"
                d="M8.29199 15.9395L13.292 10.9395L8.29199 5.93945"
                stroke="#D1D5DB"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </g>
          </svg>
        </div>
      </div> -->
    </div>
    <div class="home_activity_content">
      <div
        class="home_activity_card"
        v-for="item in activityList"
        :key="item.id"
        @click="link(item.linkUrl)"
      >
        <div class="activity_card_image">
          <img :src="item.bannerImage" alt="activity_card_image" />
        </div>
        <div class="activity_card_title">{{ item.title }}</div>
        <div class="activity_card_time">
          <div v-if="item.endTime">
            <span>{{ item.startTime }}</span
            >-<span>{{ item.endTime }}</span>
          </div>
          <div v-else>
            <span>{{ item.startTime }}</span>
          </div>
        </div>
        <div class="activity_card_content">{{ item.description }}</div>
      </div>
    </div>
    <div class="bottom_box">
      <div
        class="home_activity_bottom"
        :class="isOpen ? 'isOpen' : ''"
        @click="expandAll"
      >
        <span class="bottom_btn">收起全部</span>
        <img
          src="@/assets/img/home_mobile/chevron-down.png"
          alt="activity_bottom_arrow"
        />
      </div>
    </div>
  </div>
</template>

<script scoped>
import { getActivityList } from "@/api/home";
import { formatTimestamp } from "@/utils/common";

export default {
  name: "MobileHomeActivity",
  methods: {
    getActivity() {
      getActivityList({
        page: 1,
        pageSize: 100,
      }).then((res) => {
        this.pageTotal = res.data.pages;
        this.activityList = res.data.records;
        this.activityList.forEach((item) => {
          item.startTime = formatTimestamp(item.startTime);
          if (item.endTime !== null) {
            item.endTime = formatTimestamp(item.endTime);
          }
        });
      });
    },
    // handleSkip(type) {
    //   console.log(type);
    //   if (type === 1 && this.currentPage > 1) {
    //     this.currentPage--;
    //     this.getActivity();
    //   } else if (type === 2 && this.currentPage < this.pageTotal) {
    //     this.currentPage++;
    //     this.getActivity();
    //   }
    // },
    expandAll() {
      console.log(2222222222);

      this.$router.back();
    },
    link(url) {
      window.open(url, "_blank");
    },
  },
  mounted() {
    this.getActivity();
  },
  data() {
    return {
      currentPage: 1,
      pageTotal: 0,
      activityList: [],
      isOpen: false,
    };
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.home_activity {
  width: 100vw;
  margin: 0 auto;
  padding: 65px 0;
}

.home_activity_top {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.home_activity_title {
  font-family: "HarmonyOS Sans SC-Bold";
  font-weight: bold;
  font-size: 24px;
  color: #1f2937;
  line-height: 24px;
  text-align: center;
  margin: 0 auto;
}

.home_skip_btn {
  display: flex;
}

.home_skip_btn > .btn {
  width: 46px;
  height: 46px;
  background: #ffffff;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
  border-radius: 50%;
  border: 1px solid #e5e7eb;
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}

.btn.left {
  margin-right: 10px;
}

.btn.disable .btn_img path {
  stroke: #d1d5db;
}

.btn .btn_img path {
  stroke: #1f2937;
}

.home_activity_content {
  width: 100vw;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 52px;
  padding: 0 20px;
}

.home_activity_card {
  width: 162px;
  height: 250px;
  border-radius: 12px 12px 12px 12px;
  border: 1px solid #e5e7eb;
  padding: 20px;
  margin-bottom: 20px;
}

.activity_card_image > img {
  width: 100%;
  height: 80px;
}

.activity_card_title {
  height: 26px;
  line-height: 12px;
  font-weight: 500;
  font-size: 12px;
  color: #1f2937;
  line-height: 13px;
  text-align: left;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* 显示最多两行 */
  line-clamp: 2; /* 标准属性 */
  -webkit-box-orient: vertical; /* 垂直排列 */
  overflow: hidden; /* 超出部分隐藏 */
  text-overflow: ellipsis; /* 超出部分显示省略号 */
  margin-top: 22px;
}

.activity_card_time {
  font-family: "HarmonyOS Sans SC-Regular";
  font-weight: 400;
  font-size: 10px;
  color: #3b82f6;
  line-height: 9px;
  text-align: left;
  margin-top: 10px;
}

.activity_card_content {
  font-family: "HarmonyOS Sans SC-Regular";
  font-weight: 400;
  font-size: 10px;
  color: #6b7280;
  line-height: 14px;
  text-align: left;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 4; /* 显示最多两行 */
  line-clamp: 4; /* 标准属性 */
  -webkit-box-orient: vertical; /* 垂直排列 */
  overflow: hidden; /* 超出部分隐藏 */
  text-overflow: ellipsis; /* 超出部分显示省略号 */
  margin-top: 1px;
}

.bottom_box {
  width: 100%;
  position: fixed;
  bottom: 4%;
}

.home_activity_bottom {
  width: 107px;
  height: 38px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 32px;
  background-color: rgba(250, 250, 250, 0.5);
  border-radius: 8px;
  margin: 0 auto;
}

.bottom_btn {
  font-family: "HarmonyOS Sans SC-Bold";
  font-weight: bold;
  font-size: 15px;
  color: #3b82f6;
  text-align: center;
}

.home_activity_bottom > img {
  width: 16px;
  height: 16px;
  margin-left: 8px;
  transform: rotate(-180deg);
}
</style>

